function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "15.688",
  height: "14.921"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2552",
  "data-name": "Path 2552",
  d: "M1.175 6.081l6.669-4.844 6.668 4.844-2.547 7.84H3.723zM7.844 0L0 5.7l3 9.222h9.7L15.688 5.7z",
  fill: "#282828"
})));